<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <div class="flex flex-wrap -mr-4">
      <!--  MOJE KONTO           -->
      <div class="w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 flex mb-4 pr-4">
        <vx-card v-if="!changePasswordWindow" :title="'Moje konto'" :subtitle="'Dane które pojawią się na fakturze'" title-color="primary">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-start flex-col sm:flex-row">
                <!--                                <img :src="user_data.avatar ?? ''" class="mr-8 rounded h-24 w-24"/>-->
                <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
                <div>
                  <img :src="dataImg" class="mr-8 rounded h-24 w-24" v-if="dataImg"/>
                  <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ user_data.name }}</p>
                  <input type="file" class="hidden" ref="file" @change="updateCurrImg"
                         accept="image/*">

                  <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                  <vs-button class="mr-4 mb-4" @click="$refs.file.click()">Zmień logo
                  </vs-button>
                  <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                  <vs-button type="border" color="danger" @click="deleteCurrImg">Usuń logo</vs-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Content Row -->
          <div class="vx-row">
            <div class="vx-col w-full mt-4 ">
              <a class="text-success cursor-pointer" @click="changePasswordWindow = true">Zmień hasło</a>
            </div>
            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" label="Nazwa firmy" v-model="user_data.company"
                        v-validate="'required'" name="company"/>
              <span class="text-danger text-sm" v-show="errors.has('company')">{{
                  errors.first('company')
                }}</span>
            </div>
            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" label="Ulica" v-model="user_data.street"
                        v-validate="'required'" name="street"/>
              <span class="text-danger text-sm" v-show="errors.has('street')">{{
                  errors.first('street')
                }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
              <vs-input class="w-full mt-4" label="Kod pocztowy" v-model="user_data.zip_code"
                        v-validate="'required'" name="zip_code"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
            </div>
            <div class="vx-col md:w-2/3 w-full">
              <vs-input class="w-full mt-4" label="Miasto" v-model="user_data.city" type="city"
                        v-validate="'required'" name="city"/>
              <span class="text-danger text-sm" v-show="errors.has('city')">{{
                  errors.first('city')
                }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" label="NIP" v-model="user_data.nip"
                        v-validate="'required'" name="nip"/>
              <span class="text-danger text-sm" v-show="errors.has('nip')">{{
                  errors.first('nip')
                }}</span>
            </div>
            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" label="Numer telefonu" v-model="user_data.mobile"
                        v-validate="'numeric'" name="mobile"/>
              <span class="text-danger text-sm" v-show="errors.has('mobile')">{{
                  errors.first('mobile')
                }}</span>
            </div>
            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" label="Kod promocyjny" v-model="user_data.promo"
                        v-validate="'alpha_num'" name="promo"/>
              <span class="text-danger text-sm" v-show="errors.has('promo')">{{
                  errors.first('promo')
                }}</span>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center">
                <vs-button class="mt-2" @click="submitForm">Zapisz zmiany
                </vs-button>
              </div>
            </div>
          </div>
        </vx-card>
        <vx-card v-else :title="'Moje konto'" :subtitle="'Dane które pojawią się na fakturze'" title-color="primary">
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button class="mt-2 p-2" @click="changePasswordWindow = false" icon="arrow_back">
                Wróć
              </vs-button>
            </div>
            <div class="vx-col w-full flex flex-col justify-center items-center gap-4 mt-4">
              <vs-input
                  class="w-full"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  type="password" placeholder="nowe hasło" v-model="password"></vs-input>
              <vs-input
                  class="w-full"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  type="password" placeholder="Potwierdzenie hasła" v-model="passwordConfirm"></vs-input>
            </div>
            <div class="vx-col w-full">
              <div class="mt-2 flex flex-wrap items-center justify-center">
                <vs-button class="mt-2" @click="changePassword">Zapisz zmiany
                </vs-button>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="w-full sm:w-1 md:w-1 lg:w-2/3 xl:w-2/3 flex flex-wrap">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/3 pr-4 pb-4" :key="index"
             v-for="(item, index) in memberships">
          <vx-card class="p-2">
            <div class="text-center">
              <h4 class="text-grey">Abonament na {{ item.days }} dni</h4>
            </div>
            <div class="text-center mt-4">
              <h2>{{ item.price }} zł</h2>
            </div>
            <div class="text-center mt-4">
              <p>Wartości odżywcze widoczne przez {{ item.days }} dni.</p>
              <p class="mt-2">Dostęp do stworzonych produktów po wygaśnięciu abonamentu</p>
              <p class="mt-2">Darmowe aktualizacje</p>
              <p class="mt-2">Koszt całkowity to {{ item.price }} zł netto</p>
            </div>
            <div class="text-center place-self-center mt-1" style="font-size: 0.8rem">
              <vs-button v-on:click="toCheckout(item.id)" class="mt-4 shadow-lg" type="gradient"
                         color="#28c76f" gradient-color-secondary="#28c76f">Wybieram
              </vs-button>
<!--              <p>Jeśli chcesz wykupić abonament, zadzwoń do nas na <a href="tel:880504461">880 504 461</a> lub napisz na <a href="mail:office@runbyit.com">office@runbyit.com</a></p>-->
<!--              <p>Wystawimy Ci fakturę ręcznie.</p>-->
            </div>
          </vx-card>
        </div>
      </div>

    </div>

    <div class="w-full flex flex-wrap mb-4">
      <vx-card :title="'Certyfikat'">
        <vs-button v-on:click="certificate()" class="mt-4 shadow-lg" type="gradient"
                   color="#28c76f" gradient-color-secondary="#28c76f">Certyfikat
        </vs-button>
      </vx-card>
    </div>

    <!--   MEMBERSHIPS         -->
    <div class="flex" v-if="invoices">
      <vx-card :title="'Faktury'">
        <vs-table max-items="10" stripe :data="invoices">

          <template slot="thead">
            <vs-th>Nr faktury</vs-th>
            <vs-th>Kwota</vs-th>
            <vs-th>&nbsp;</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].number">
                {{ data[indextr].description }}
              </vs-td>

              <vs-td :data="data[indextr].amount">
                {{ (data[indextr].amount * 0.01).toFixed(2) }} zł
              </vs-td>

              <vs-td :data="data[indextr].id" class="text-center">
                <div v-if="data[indextr].is_fakturownia" class="fonticon-wrap">
                  <i v-on:click="fetchFakturowniaInvoice(data[indextr].id)"
                     class="feather icon-save"></i>&nbsp;&nbsp;
                  <i v-on:click="fetchFakturowniaInvoice(data[indextr].id)"
                     class="feather icon-at-sign"></i>
                </div>
                <div v-else class="fonticon-wrap">
                  <i v-on:click="invoice(data[indextr].id)"
                     class="feather icon-save"></i>
                </div>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import UserEditTabAccount from './UserEditTabAccount.vue'
import {Validator} from 'vee-validate';
import axios from 'axios'


// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    UserEditTabAccount
  },
  data() {
    return {
      password: null,
      passwordConfirm: null,
      changePasswordWindow: false,
      dataImg: null,
      file: null,
      memberships: [
        {
          id: 1,
          days: 30,
          price: "289,00"
        },
        {
          id: 2,
          days: 180,
          price: "999,00"
        },
        {
          id: 3,
          days: 360,
          price: "1490,00"
        }
      ],
      invoices: [],
      user_data: {},
      user_not_found: false,
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    changePassword() {
      // validations
      if(!this.password) {
        return this.$vs.notify({
          title: 'error',
          color: 'danger',
          text: 'Hasło jest puste'
        })
      }
      if(this.password !== this.passwordConfirm) {
        return this.$vs.notify({
          title: 'error',
          color: 'danger',
          text: 'Hasła nie pasują do siebie'
        })
      }

      // send password change request
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/v1/auth/password-change',{
        password: this.password,
      }).then(response => {
        //console.log(response);
        // show success message and redirect to login
        if(response.data.type === 'success') {
          this.$vs.notify({title:'Sukces.',text: response.data.message, color:'primary'});
          this.changePasswordWindow = false;
        }
        else {
          this.$vs.notify({title:'Błąd.',text: response.data.message, color:'warning'})
        }
      }).catch(response => {
        // show failure message
        this.$vs.notify({
          title: 'message',
          text: response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    certificate() {
      axios({
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/user/cert/' + this.user_data.id,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Certyfikat_Vitme.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    invoice(id) {
      axios({
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/invoice/' + id,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Faktura_Vitme_' + id + '.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    fetchFakturowniaInvoice(id) {
      axios({
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/fakturownia-invoice/' + id,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Faktura_Vitme_f_' + id + '.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    emailFakturowniaInvoice(id){
      axios({
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/fakturownia-email/' + id,
        method: 'GET',
        //responseType: 'blob', // important
      }).then((response) => {
        console.log(response.data.data);
        if(response.data.data.result === 'success') {
          this.$vs.notify({title:'Sukces.',text:'Faktura została wysłana na adres email', color:'primary'})
        }
        else {
          this.$vs.notify({title:'Błąd.',text:'Błąd w wysyłaniu faktury na adres email', color:'warning'})
        }
      });
    },
    updateCurrImg(input) {
      let uploadedFiles = this.$refs.file.files;
      this.file = uploadedFiles[0];

      console.log('FILE', this.file);

      let formData = new FormData();
      formData.append('file', this.file);
      this.dataImg = this.file;
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/v1/user/logo/' + this.user_data.id,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then( () => {
        console.log('SUCCESS!!');
        this.$vs.notify({title:'Sukces.',text:'Logo zostało zaktualizowane', color:'primary'})
        caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))));
      })
          .catch(function () {
            console.log('FAILURE!!');
          });

      const reader = new FileReader()
      reader.onload = e => {
        this.dataImg = e.target.result
      }
      reader.readAsDataURL(this.file);
    },
    deleteCurrImg() {

      axios({
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/user/logo/' + this.user_data.id,
        method: 'DELETE',
      }).then( (response) => {
        if(response.data.success === 1) {
          this.$vs.notify({title:'Sukces.',text:'Logo zostało usunięte', color:'primary'})
        }
        else {
          this.$vs.notify({title:'Błąd.',text:'Logo nie zostało usunięte', color:'warning'})
        }

        console.log('SUCCESS!!');
      })
          .catch(function () {
            console.log('FAILURE!!');
          });

    },
    fetchOne(userId) {
      let url = process.env.VUE_APP_API_ENDPOINT + '/v1/user/' + userId;
      this.$http.get(url).then(response => {
        this.user_data = response.data.data.data;
        this.dataImg = process.env.VUE_APP_API_ENDPOINT + '/' + response.data.data.logo + '?ver=' + Date.now();
      });
    },
    fetchInvoices(userId) {
      let url = process.env.VUE_APP_API_ENDPOINT + '/v1/payments/invoices';
      this.$http.get(url).then(response => {
        this.invoices = response.data.data;
      });
    },
    submitForm() {
      /* eslint-disable */
      this.$validator.validateAll().then(result => {
        console.log(this.$validator);
        if (result) {
          this.saveData();
        }
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    saveData() {
      let requestObject = {
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/user/' + this.user_data.id,
        method: 'put',
        data: this.user_data
      }
      this.$http.request(requestObject).then(response => {
        if (response.data.data === true) {
          this.$vs.dialog({
            color: 'success',
            title: `Wiadomość`,
            text: 'Dane uaktualnione',
            accept: this.acceptAlert
          })
          //  this.resetForm();
          this.fetchData();
        } else {
          this.$vs.dialog({
            color: 'warning',
            title: `Błąd`,
            text: 'Wystąpił błąd podczas zapisywania. Spróbuj jeszcze raz lub skontaktuj się z administratore,',
            accept: this.acceptAlert
          })
        }
      });
    },
    toCheckout(subscriptionId) {
      this.$router.push({ name: 'Podsumowanie', params: { id: subscriptionId } })
    },
    paymentOption(subscriptionId) {
      let requestObject = {
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/request',
        method: 'POST',
        data: {
          subscription: subscriptionId,
          userId: this.user_data.id,
          email: this.user_data.email,
          companyName: this.user_data.company
        }
      }
      this.$http.request(requestObject).then(response => {
        console.log('mem resp', response);
        if (typeof response.data.data.url !== undefined) {
          window.location.href = response.data.data.url;
        } else {
          this.$vs.dialog({
            color: 'warning',
            title: `Błąd`,
            text: 'Wystąpił błąd podczas wybierania płatności. Spróbuj jeszcze raz lub skontaktuj się z administratore,',
            accept: this.acceptAlert
          })
        }
      });
    },
    resetForm() {
      this.user_data = {};
    },
    deleteCurrImg() {
      axios({
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/user/logo/' + this.user_data.id,
        method: 'DELETE',
      }).then( (response) => {
        if(response.data.success === 1) {
          this.$vs.notify({title:'Sukces.',text:'Logo zostało usunięte', color:'primary'})
        }
        else {
          this.$vs.notify({title:'Błąd.',text:'Logo nie zostało usunięte', color:'warning'})
        }
        console.log('SUCCESS!!');
      })
          .catch(function () {
            console.log('FAILURE!!');
          });

    }
  },
  created() {
    // Register Module UserManagement Module
    //this.user_data = this.activeUserInfo();
    this.fetchOne(this.activeUserInfo.id)
    this.fetchInvoices(this.activeUserInfo.id)
  }
}

</script>
